import PageLayout from "layouts/PageLayout";
import TableData from "./tableData";

function BulkOrders() {
  return (
    <PageLayout
      title={'Bulk Orders'}
    >
      <TableData />
    </PageLayout>
  );
}

export default BulkOrders;
